import { render } from "./Goodbye.vue?vue&type=template&id=5ea3ec68&scoped=true"
import script from "./Goodbye.vue?vue&type=script&lang=js"
export * from "./Goodbye.vue?vue&type=script&lang=js"

import "./Goodbye.vue?vue&type=style&index=0&id=5ea3ec68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea3ec68"]])

export default __exports__